module.exports = __webpack_public_path__ + "img/app.eb93ce0a.png";